import { Component, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { LayoutResolver } from 'app/views/presentations/layouts/layoutResolver';

@Component({
    selector: 'psm-layout-resolver',
    templateUrl: 'layoutResolver.component.html'
})

export class LayoutResolverComponent implements OnInit {
    @Input() public type: string;
    @ViewChild('layout', { read: ViewContainerRef, }) private layoutContainer: ViewContainerRef;

    constructor(private layoutResolver: LayoutResolver) { }

    public ngOnInit() {
        const factory = this.layoutResolver.resolveComponent(this.type);
        this.layoutContainer.createComponent(factory);
    }
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layoutResolver.component.ts